import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { DueDate, NonPaymentTypes, Whitelist } from '~/types/nonPayment';
import { getDueDate, getWhitelist } from '~/services/NonPayment';

export function useDueDate(tipo: NonPaymentTypes): UseQueryResult<DueDate[]> {
  return useQuery<DueDate[]>(['afterDueDate'], () => getDueDate(tipo), {
    staleTime: 1000 * 60 * 10, // 10 minutes
  });
}

export function useWhitelist(): UseQueryResult<Whitelist[]> {
  return useQuery<Whitelist[]>(['whitelist'], () => getWhitelist(), {
    staleTime: 1000 * 60 * 10, // 10 minutes
  });
}
